import { render, staticRenderFns } from "./WcRet.vue?vue&type=template&id=9cb780c4"
import script from "./WcRet.vue?vue&type=script&lang=js"
export * from "./WcRet.vue?vue&type=script&lang=js"
import style0 from "./WcRet.vue?vue&type=style&index=0&id=9cb780c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports